import { AccountTypeID, RpAccountType } from "../../config/Constants"
import { Filter, Sort } from "../GridRequest"
import GridResponse from "../GridResponse"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PoolMemberRecord from "./PoolMembersModel/PoolMemberRecord"

const Columns = ["ActiveSince", "Company", "IDNumber", "Occupation", "Location", "Name", "RegulatoryMode", "Category", "Supervisor1", "Supervisor2",
"HireDate", "TerminationDate", "PreEmploymentTestOnFile", "Gender", "DateOfBirth", "AddressLine1", "City", "State", "Zip", "WorkPhone", "CellPhone",
"Email", "User1", "User2", "User3", "User4", "User5", "User6", "User7", "User8", "User9", "User10", "Manager", "ReasonForInactivation"] as const
type Column = typeof Columns[number]

export type ColumnFilters = Record<Column, string[]>
export type PoolMembersGridResponse = GridResponse<PoolMemberRecord> & ColumnFilters

export interface PoolMembersOptions {
  poolId: number
  inactive: boolean | null
  search: {
    field: string
    text: string
  }
  sort: Sort
  filters: Filter[]
  columnFilters: Filter[]
  pageNumber: number
  pageSize: number
}

function filters(filters: Filter[] = []) {
  return {
    Location: filters.find(filter => filter.column === "Location")?.values || [],
    RegulatoryMode: filters.find(filter => filter.column === "RegulatoryMode")?.values || [],
    ID: filters.find(filter => filter.column === "IDNumber")?.values || [],
    Company: filters.find(filter => filter.column === "Company")?.values || [],
    Name: filters.find(filter => filter.column === "Name")?.values || [],
    ActiveSince: filters.find(filter => filter.column === "ActiveSince")?.values || [],
    Occupation: filters.find(filter => filter.column === "Occupation")?.values || [],
    Category: filters.find(filter => filter.column === "Category")?.values || [],
    Supervisor1: filters.find(filter => filter.column === "Supervisor1")?.values || [],
    Supervisor2: filters.find(filter => filter.column === "Supervisor2")?.values || [],
    HireDate: filters.find(filter => filter.column === "HireDate")?.values || [],
    TerminationDate: filters.find(filter => filter.column === "TerminationDate")?.values || [],
    PreEmploymentTestOnFile: filters.find(filter => filter.column === "PreEmploymentTestOnFile")?.values || [],
    Gender: filters.find(filter => filter.column === "Gender")?.values || [],
    DateOfBirth: filters.find(filter => filter.column === "DateOfBirth")?.values || [],
    AddressLine1: filters.find(filter => filter.column === "AddressLine1")?.values || [],
    City: filters.find(filter => filter.column === "City")?.values || [],
    State: filters.find(filter => filter.column === "State")?.values || [],
    Zip: filters.find(filter => filter.column === "Zip")?.values || [],
    WorkPhone: filters.find(filter => filter.column === "WorkPhone")?.values || [],
    CellPhone: filters.find(filter => filter.column === "CellPhone")?.values || [],
    Email: filters.find(filter => filter.column === "Email")?.values || [],
    User1: filters.find(filter => filter.column === "User1")?.values || [],
    User2: filters.find(filter => filter.column === "User2")?.values || [],
    User3: filters.find(filter => filter.column === "User3")?.values || [],
    User4: filters.find(filter => filter.column === "User4")?.values || [],
    User5: filters.find(filter => filter.column === "User5")?.values || [],
    User6: filters.find(filter => filter.column === "User6")?.values || [],
    User7: filters.find(filter => filter.column === "User7")?.values || [],
    User8: filters.find(filter => filter.column === "User8")?.values || [],
    User9: filters.find(filter => filter.column === "User9")?.values || [],
    User10: filters.find(filter => filter.column === "User10")?.values || [],
    Manager: filters.find(filter => filter.column === "Manager")?.values || [],
    ReasonForInactivation: filters.find(filter => filter.column === "ReasonForInactivation")?.values || [],
  }
}

function gridParams(options: PoolMembersOptions): string {
  return JSON.stringify({
    PoolID: options.poolId,
    RandomSelection: false,
    Inactive: options.inactive,
    RpAccountType: RpAccountType,
    PersonID: 0,
    SortGrid: { SortColumn: options.sort?.column || "", SortOrder: options.sort?.order.toUpperCase() === "DESC" ? "DSC" : options.sort?.order.toUpperCase() },
    Filters: filters(options.columnFilters),
    GridFilters: filters(options.filters),
    PageNumber: options.pageNumber,
    PageSize: options.pageSize || 20,
  })
}

function exportParams(options: PoolMembersOptions): string {
  return JSON.stringify({
    Filters: filters(options.columnFilters),
    Inactive: options.inactive,
    PoolID: options.poolId,
    RandomSelection: false,
    RpAccountType: RpAccountType,
  })
}

function printParams(values: number[], options: PoolMembersOptions): string {
  return JSON.stringify({
    AccountTypeID: AccountTypeID,
    Inactive: options.inactive,
    PersonID: values,
    PoolID: options.poolId,
    RandomSelection: false,
    RpAccountType: RpAccountType,
  })
}

export const PoolMembersGridObservable = (params: PoolMembersOptions) => ObservableFromFetch<PoolMembersGridResponse>("RandomTest/GetPoolMembersList", gridParams(params))
export const PoolMembersExportCsv = (params: PoolMembersOptions) => ObservableFromFetch<string>("RandomTest/ExportPoolMember", exportParams(params))
export const PoolMembersPrint = (values: number[], params: PoolMembersOptions) => ObservableFromFetch<string>("WorkforceRandomTest/PrintPoolMember", printParams(values, params))

export function ChangePersonStatus(poolID: number, personIDs: number[], toogleMode: number, accountID: number) {
  const requestBody = JSON.stringify({
    PoolID: poolID,
    PersonIDs: personIDs,
    ToogleMode: toogleMode,
    AccountID: accountID
  })
  return ObservableFromFetch<string>("RandomTest/InactivePerson", requestBody)
}